/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ClientApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrgs(): Observable<SwaggerResponse<Organization[]>> {
        let url_ = this.baseUrl + "/api/v1/Application/orgs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgs(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<Organization[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<Organization[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrgs(response: HttpResponseBase): Observable<SwaggerResponse<Organization[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Organization[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getSocialMediaServices(): Observable<SwaggerResponse<SocialMediaService[]>> {
        let url_ = this.baseUrl + "/api/v1/Application/socialMediaServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSocialMediaServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSocialMediaServices(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<SocialMediaService[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<SocialMediaService[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetSocialMediaServices(response: HttpResponseBase): Observable<SwaggerResponse<SocialMediaService[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SocialMediaService.fromJS(item));
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SocialMediaService[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getCurrentUser(): Observable<SwaggerResponse<UserSummary>> {
        let url_ = this.baseUrl + "/api/v1/Application/users/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<UserSummary>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<UserSummary>>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<SwaggerResponse<UserSummary>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSummary.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorDto.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserSummary>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    deleteImage(id: number): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/delete-image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<boolean>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<boolean>>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getThumbnails(): Observable<SwaggerResponse<ImageThumbnailResource[]>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-thumbnails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThumbnails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThumbnails(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<ImageThumbnailResource[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<ImageThumbnailResource[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetThumbnails(response: HttpResponseBase): Observable<SwaggerResponse<ImageThumbnailResource[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageThumbnailResource.fromJS(item));
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ImageThumbnailResource[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getImage(id: number): Observable<SwaggerResponse<ImageWithoutImageDataResource>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImage(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<ImageWithoutImageDataResource>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<ImageWithoutImageDataResource>>><any>_observableThrow(response_);
        }));
    }

    protected processGetImage(response: HttpResponseBase): Observable<SwaggerResponse<ImageWithoutImageDataResource>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageWithoutImageDataResource.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ImageWithoutImageDataResource>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    getImages(): Observable<SwaggerResponse<ImageWithoutImageDataResource[]>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-images";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<ImageWithoutImageDataResource[]>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<ImageWithoutImageDataResource[]>>><any>_observableThrow(response_);
        }));
    }

    protected processGetImages(response: HttpResponseBase): Observable<SwaggerResponse<ImageWithoutImageDataResource[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageWithoutImageDataResource.fromJS(item));
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ImageWithoutImageDataResource[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param fileName (optional) 
     * @param imageFile (optional) 
     * @param createdBy (optional) 
     * @param orgCode (optional) 
     * @return Success
     */
    postImage(fileName: string | undefined, imageFile: FileParameter | undefined, createdBy: string | undefined, orgCode: string | undefined): Observable<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/post-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (createdBy === null || createdBy === undefined)
            throw new Error("The parameter 'createdBy' cannot be null.");
        else
            content_.append("CreatedBy", createdBy.toString());
        if (orgCode === null || orgCode === undefined)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else
            content_.append("OrgCode", orgCode.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostImage(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<number>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<number>>><any>_observableThrow(response_);
        }));
    }

    protected processPostImage(response: HttpResponseBase): Observable<SwaggerResponse<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = resultData201 !== undefined ? resultData201 : <any>null;
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getImageFileById(id: number): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-image-file-by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "image/png"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageFileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageFileById(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageFileById(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: <any>responseBlob, status: status, headers: _headers }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getImageFileByOrgcode(orgcode: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-image-file-by-orgcode/{orgcode}";
        if (orgcode === undefined || orgcode === null)
            throw new Error("The parameter 'orgcode' must be defined.");
        url_ = url_.replace("{orgcode}", encodeURIComponent("" + orgcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "image/png"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageFileByOrgcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageFileByOrgcode(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageFileByOrgcode(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: <any>responseBlob, status: status, headers: _headers }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getImageThumbnail(id: number): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/LogoImage/get-image-thumbnail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "image/png"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageThumbnail(<any>response_);
                } catch (e) {
                    return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwaggerResponse<FileResponse>>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageThumbnail(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: <any>responseBlob, status: status, headers: _headers }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ErrorDto implements IErrorDto {
    discriminator?: string | undefined;
    innerException?: ErrorDto;
    message?: string | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.innerException = data.innerException && !(<any>data.innerException).toJSON ? new ErrorDto(data.innerException) : <ErrorDto>this.innerException; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.innerException = _data["innerException"] ? ErrorDto.fromJS(_data["innerException"]) : <any>undefined;
            this.message = _data["message"];
            this.source = _data["source"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["innerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["source"] = this.source;
        data["stackTrace"] = this.stackTrace;
        return data; 
    }
}

export interface IErrorDto {
    discriminator?: string | undefined;
    innerException?: IErrorDto;
    message?: string | undefined;
    source?: string | undefined;
    stackTrace?: string | undefined;
}

export class ImageThumbnailResource implements IImageThumbnailResource {
    id?: number;
    fileName?: string | undefined;
    imageDataThumbnail?: string | undefined;
    orgCode?: string | undefined;

    constructor(data?: IImageThumbnailResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.imageDataThumbnail = _data["imageDataThumbnail"];
            this.orgCode = _data["orgCode"];
        }
    }

    static fromJS(data: any): ImageThumbnailResource {
        data = typeof data === 'object' ? data : {};
        let result = new ImageThumbnailResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["imageDataThumbnail"] = this.imageDataThumbnail;
        data["orgCode"] = this.orgCode;
        return data; 
    }
}

export interface IImageThumbnailResource {
    id?: number;
    fileName?: string | undefined;
    imageDataThumbnail?: string | undefined;
    orgCode?: string | undefined;
}

export class ImageWithoutImageDataResource implements IImageWithoutImageDataResource {
    id?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    fileName?: string | undefined;
    orgCode?: string | undefined;

    constructor(data?: IImageWithoutImageDataResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.orgCode = _data["orgCode"];
        }
    }

    static fromJS(data: any): ImageWithoutImageDataResource {
        data = typeof data === 'object' ? data : {};
        let result = new ImageWithoutImageDataResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["orgCode"] = this.orgCode;
        return data; 
    }
}

export interface IImageWithoutImageDataResource {
    id?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    fileName?: string | undefined;
    orgCode?: string | undefined;
}

export class Organization implements IOrganization {
    externalId?: number;
    externalPropertyIds?: number[] | undefined;
    fullAddress?: string | undefined;
    name?: string | undefined;
    orgCode?: string | undefined;
    primaryPhone?: string | undefined;
    websiteUrl?: string | undefined;
    socialUrls?: { [key: string]: string; } | undefined;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["externalPropertyIds"])) {
                this.externalPropertyIds = [] as any;
                for (let item of _data["externalPropertyIds"])
                    this.externalPropertyIds!.push(item);
            }
            this.fullAddress = _data["fullAddress"];
            this.name = _data["name"];
            this.orgCode = _data["orgCode"];
            this.primaryPhone = _data["primaryPhone"];
            this.websiteUrl = _data["websiteUrl"];
            if (_data["socialUrls"]) {
                this.socialUrls = {} as any;
                for (let key in _data["socialUrls"]) {
                    if (_data["socialUrls"].hasOwnProperty(key))
                        this.socialUrls![key] = _data["socialUrls"][key];
                }
            }
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        if (Array.isArray(this.externalPropertyIds)) {
            data["externalPropertyIds"] = [];
            for (let item of this.externalPropertyIds)
                data["externalPropertyIds"].push(item);
        }
        data["fullAddress"] = this.fullAddress;
        data["name"] = this.name;
        data["orgCode"] = this.orgCode;
        data["primaryPhone"] = this.primaryPhone;
        data["websiteUrl"] = this.websiteUrl;
        if (this.socialUrls) {
            data["socialUrls"] = {};
            for (let key in this.socialUrls) {
                if (this.socialUrls.hasOwnProperty(key))
                    data["socialUrls"][key] = this.socialUrls[key];
            }
        }
        return data; 
    }
}

export interface IOrganization {
    externalId?: number;
    externalPropertyIds?: number[] | undefined;
    fullAddress?: string | undefined;
    name?: string | undefined;
    orgCode?: string | undefined;
    primaryPhone?: string | undefined;
    websiteUrl?: string | undefined;
    socialUrls?: { [key: string]: string; } | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class SocialMediaService implements ISocialMediaService {
    applicationKey?: string | undefined;
    entrataKey?: string | undefined;
    iconUrl?: string | undefined;
    useDefaultIfMissing?: string | undefined;

    constructor(data?: ISocialMediaService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationKey = _data["applicationKey"];
            this.entrataKey = _data["entrataKey"];
            this.iconUrl = _data["iconUrl"];
            this.useDefaultIfMissing = _data["useDefaultIfMissing"];
        }
    }

    static fromJS(data: any): SocialMediaService {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediaService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationKey"] = this.applicationKey;
        data["entrataKey"] = this.entrataKey;
        data["iconUrl"] = this.iconUrl;
        data["useDefaultIfMissing"] = this.useDefaultIfMissing;
        return data; 
    }
}

export interface ISocialMediaService {
    applicationKey?: string | undefined;
    entrataKey?: string | undefined;
    iconUrl?: string | undefined;
    useDefaultIfMissing?: string | undefined;
}

export class UserSummary implements IUserSummary {
    userId?: number;
    email?: string | undefined;
    isSuperUser?: boolean;
    name?: string | undefined;
    orgCode?: string | undefined;
    title?: string | undefined;
    objectId?: string;

    constructor(data?: IUserSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.isSuperUser = _data["isSuperUser"];
            this.name = _data["name"];
            this.orgCode = _data["orgCode"];
            this.title = _data["title"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): UserSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["isSuperUser"] = this.isSuperUser;
        data["name"] = this.name;
        data["orgCode"] = this.orgCode;
        data["title"] = this.title;
        data["objectId"] = this.objectId;
        return data; 
    }
}

export interface IUserSummary {
    userId?: number;
    email?: string | undefined;
    isSuperUser?: boolean;
    name?: string | undefined;
    orgCode?: string | undefined;
    title?: string | undefined;
    objectId?: string;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}